import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import IMAGES from '../../../images/google';

const Item = ({ isFirst, title, link, children, images }) => {
  return (
    <li className={isFirst ? '' : 'border-t border-gray-200'}>
      <Link
        to={link}
        className="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
      >
        <div className="flex items-center px-4 py-5 sm:px-6">
          <div className="flex items-center flex-1 min-w-0">
            <div className="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4 ">
              <div className="flex items-center text-lg font-semibold text-indigo-600 truncate tracking-tight ">
                <svg
                  className="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{title}</span>
              </div>
              <div className="hidden md:block">
                <div className="flex items-center text-sm leading-5 text-gray-500">
                  {children}
                </div>
                <div className="mt-4">
                  {images.map((name) => {
                    return (
                      <img
                        className="inline-block h-6 w-6 mr-1"
                        src={IMAGES[name]}
                        alt={name}
                        key={name}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div>
            <svg
              className="w-5 h-5 text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </Link>
    </li>
  );
};

Item.defaultProps = {
  isFirst: false,
};

Item.propTypes = {
  isFirst: PropTypes.bool,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Item;
